import React from 'react'
import loaderGif from '../assets/animated-loader-v5-300.gif'
import t from '../service/translate.service'

const LoadingPageOverlay = () => {
  return (
    <div className="loading-page-overlay">
      <div className="gif">
        <img src={loaderGif} alt={t.LOADING} />
      </div>
      <p role="alert" aria-live="assertive" className="sr-only">{t.LOADING}</p>
    </div>
  );
}

export default LoadingPageOverlay
